// src/ui/Icon.tsx: one inline SVG icon from the Phosphor set (icons.ts, 256 grid, fill=currentColor). `filled` picks the fill weight. Decorative by default
// (aria-hidden); pass `label` when the icon is the only content of a control that has no other name.
import { h } from "preact";
import { ICONS, type IconName } from "./icons";

export type { IconName };

export function Icon(props: { name: IconName; size?: "xs" | "sm" | "md" | "lg"; class?: string; label?: string; filled?: boolean }) {
  const icon = ICONS[props.name];
  const paths = props.filled ? icon.f : icon.r;
  const cls = ["icon", props.size && props.size !== "md" ? `icon-${props.size}` : "", props.class ?? ""].filter(Boolean).join(" ");
  return h(
    "svg",
    {
      class: cls,
      viewBox: "0 0 256 256",
      fill: "currentColor",
      "aria-hidden": props.label ? undefined : "true",
      role: props.label ? "img" : undefined,
      "aria-label": props.label,
      focusable: "false",
    },
    paths.map((d, i) => h("path", { key: i, d })),
  );
}
